/**
 * VIEW SUCCESS — تأیید سفارش و وضعیت زنده
 */

import { formatPrice, escapeHtml } from '../utils.js';

export function render(orderInfo, orderType) {
  if (!orderInfo) return;
  document.getElementById('success-order-id').textContent      = orderInfo.id;
  document.getElementById('success-order-total').textContent   = formatPrice(orderInfo.payable);
  document.getElementById('success-receiver-name').textContent = escapeHtml(orderInfo.receiverName);
  _setLastStep(orderType);
  _resetTrackerSteps();
}

function _setLastStep(orderType) {
  const steps = {
    delivery: { title: 'تحویل به پیک',       desc: 'غذا تحویل سفیر ارسال شد و در مسیر خانه شماست' },
    takeaway: { title: 'آماده تحویل حضوری',   desc: 'سفارش شما آماده است، به پیشخوان مراجعه کنید' },
    dinein:   { title: 'سرو روی میز',         desc: 'غذا آماده شده و روی میز شما سرو می‌گردد' },
  };
  const step = steps[orderType] || steps.delivery;
  document.getElementById('tracker-last-step-title').textContent = step.title;
  document.getElementById('tracker-last-step-desc').textContent  = step.desc;
}

function _resetTrackerSteps() {
  ['step-received','step-cooking','step-delivering'].forEach(id => {
    const el = document.getElementById(id);
    if (el) el.className = 'tracker-step';
  });
  document.getElementById('step-received')?.classList.add('active');
}

export function updateTracker(submittedAt) {
  const elapsed = Date.now() - submittedAt;
  if (elapsed > 15_000) document.getElementById('step-cooking')?.classList.add('active');
  if (elapsed > 35_000) document.getElementById('step-delivering')?.classList.add('active');
}
